import React from 'react';
import { Link } from 'react-router-dom';
import Supplies from "../../assests/school_supplies.jpg";
import drumbeats from "../../assests/drums.jpg";
import solarpanels from "../../assests/solarpanels.jpg";
import churchrepairs from "../../assests/church_repairs.jpg";
import newchurchbuilding from "../../assests/new_church_building.jpg";
import yellowbus from "../../assests/yellowbus.jpg";
import tirtusfamily from "../../assests/tirtus-fam.jpg";
import tirtus from "../../assests/tirtus_hero.jpg";

function DevelopmentProjects() {
  const ph = (name) =>
    `https://placehold.co/420x250/d0d0d0/555?text=${encodeURIComponent(
      name
    )}`;

  const cost = (text) => (
    <span style={{ color: "#c47a1e", fontWeight: 700 }}>
      {text}
    </span>
  );

  const projects = [
    {
      no: "#1",
      title: "Bible",
      video: "https://www.youtube.com/embed/39s9urUpIQw",
      image: "",
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=MZMA6AGT4FYK4",
      paragraphs: [
        <>
          Help spread the good news to the one billion plus souls in India by
          providing a Bible for new believers and evangelism.{" "}
          {cost("One Bible would cost $5.")}
        </>,
        <>Would you consider providing a Bible?</>,
      ],
    },

    {
      no: "#2",
      title: "Books for the Library",
      video: "https://www.youtube.com/embed/Y9OX2cDmabQ",
      image: ph("Books Project"),
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=29BAFST6GSBRN",
      paragraphs: [
        <>
          Seminary students, high school students, grammar school students,
          teachers, faculty and members of the community use the library on
          campus. {cost("The books would cost $20.")}
        </>,
        <>
          Would you consider donating books for the library? Your gift will
          allow us to continue to provide current literature and research
          materials.
        </>,
      ],
    },

    {
      no: "#3",
      title: "School Supplies",
      video: "",
      image: Supplies,
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=ZU5C6A2CLHBTE",
      paragraphs: [
        <>
          All the lessons at our schools are completed on slates for the young
          children. Each student needs notebooks, pens, folders etc.{" "}
          {cost("The school supplies per student would cost $30.")} Would you
          consider donating school supplies?
        </>,
        <>
          Your gift will provide supplies for a student's one full school
          year.
        </>,
      ],
    },

    {
      no: "#4",
      title: "Evangelism Tools",
      video: "",
      image: drumbeats,
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=ZU5C6A2CLHBTE",
      paragraphs: [
        <>
          These tools enable us to bring the Gospel to people throughout
          India. These components are light-weight and perfectly suited to be
          set up in remote locations.{" "}
          {cost("Evangelism tools would cost between $100 and $2,000.")}
        </>,
        <>
          Would you consider contributing towards our evangelism tools?
          (Microphones $100, Guitar $100, Bull Horn $100, Portable DVD Player
          $125, Drum Set $200, Full PA System for a Church $1000, Portable
          Generator $1250, Video Projector $1500, Keyboard $2000)
        </>,
      ],
    },

    {
      no: "#5",
      title: "Solar Panels",
      video: "",
      image: solarpanels,
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=SQZBUSC46NPNJ",
      paragraphs: [
        <>
          Help us extend our supply of clean, sustainable energy to the campus
          by investing in solar panels Phase 3. Once completed and operational,
          we can save additional cost per month.{" "}
          {cost("Each solar panel would cost $250.")}
        </>,
        <>Would you consider contributing to our Solar Panels Project?</>,
      ],
    },

    {
      no: "#6",
      title: "Motorcycle",
      video: "https://www.youtube.com/embed/TWdcnmiGjwM",
      image: "",
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=EW226GF3Q4PYA",
      paragraphs: [
        <>
          The pastors have an urgent need to oversee each village church
          plant. Some of these church plants are in remote areas and no public
          transportation is available. As the transportation needs are
          changing in India, we also need to get new tools for our pastors in
          the field. {cost("A motorcycle would cost $1,200.")}
        </>,
        <>
          This will become the transportation for evangelism and also for the
          pastor and his family as a family vehicle. Would you consider
          participating in a motorcycle purchase?
        </>,
      ],
    },

    {
      no: "#7",
      title: "Church Repairs",
      video: "",
      image: churchrepairs,
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=M24ZJA5UA2VH6",
      paragraphs: [
        <>
          Many churches need roofs and have other maintenance issues. Help us
          rebuild our damaged churches.{" "}
          {cost("Church repairs would cost $5,000.")}
        </>,
        <>Would you consider donating for our churches' repairs?</>,
      ],
    },

    {
      no: "#8",
      title: "New Church Building",
      video: "",
      image: newchurchbuilding,
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=MJPF7DFQD73PA",
      paragraphs: [
        <>
          In India, your gift can help us build a simple, sturdy church
          building. This building can be used for worship, discipleship, and
          spreading the Gospel. In addition, the building can serve as a school
          for the young children.{" "}
          {cost("A new church building would cost $20,000.")}
        </>,
        <>Would you consider contributing to a new church building?</>,
      ],
    },

    {
      no: "#9",
      title: "New School Bus",
      video: "",
      image: yellowbus,
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=8MRWEGEPFBDH6",
      paragraphs: [
        <>
          We need two new buses, as our current buses are too old to receive
          registration. {cost("One new bus would cost $26,500.")}
        </>,
        <>Would you consider participating in a new school bus purchase?</>,
      ],
    },
  ];

  // General Donation URL used for Titus Family Home
  const titusFamilyDonateUrl =
    "https://www.paypal.com/donate/?hosted_button_id=Y4YKUWQE3UWWY";

  return (
    <div
      style={{
        fontFamily: "'Georgia','Times New Roman',serif",
        color: "#222",
        backgroundColor: "#fff",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          padding: "0 1.5rem 3.5rem",
        }}
      >
        {/* ── Back link ── */}
        <Link
          to="/"
          style={{
            fontSize: "13px",
            color: "#c47a1e",
            textDecoration: "none",
            display: "inline-block",
            margin: "1.5rem 0 0",
            userSelect: "none",
          }}
        >
          ← Back to Home
        </Link>

        {/* ── Heading ── */}
        <h1
          style={{
            fontFamily: "'Dancing Script','Brush Script MT',cursive",
            fontSize: "2.4rem",
            color: "#c47a1e",
            margin: "1.2rem 0 0.15rem",
            fontWeight: 700,
          }}
        >
          Development Projects
        </h1>

        {/* Orange Dots */}
        <div
          style={{
            display: "flex",
            gap: "4px",
            marginBottom: "2.2rem",
          }}
        >
          {[...Array(9)].map((_, i) => (
            <div
              key={i}
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                backgroundColor: "#c47a1e",
              }}
            />
          ))}
        </div>

        {/* ── Two-column grid #1–#9 ── */}
        <div
          className="dev-projects-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "2.5rem 2.5rem",
          }}
        >
          {projects.map((p, i) => (
            <div key={i}>
              {/* Project Number */}
              <p
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  color: "#888",
                  marginBottom: "0.6rem",
                }}
              >
                {p.no}
              </p>

              {/* Image / Video */}
              <div
                style={{
                  width: "100%",
                  borderRadius: "4px",
                  overflow: "hidden",
                  marginBottom: "1rem",
                }}
              >
                {p.video ? (
                  <iframe
                    width="100%"
                    height="230"
                    src={p.video}
                    title={p.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      border: "none",
                      display: "block",
                      width: "100%",
                    }}
                  />
                ) : (
                  <img
                    src={p.image}
                    alt={p.title}
                    style={{
                      width: "100%",
                      height: "230px",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                )}
              </div>

              {/* Title */}
              <h3
                style={{
                  fontSize: "1.05rem",
                  fontWeight: 700,
                  color: "#222",
                  margin: "0 0 0.6rem",
                }}
              >
                {p.title}
              </h3>

              {/* Description */}
              {p.paragraphs.map((para, j) => (
                <p
                  key={j}
                  style={{
                    fontSize: "13.5px",
                    lineHeight: "1.75",
                    color: "#444",
                    marginBottom: "0.75rem",
                  }}
                >
                  {para}
                </p>
              ))}

              {/* GIVE Button */}
              <a
                href={p.donateUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  background: "#e87b1e",
                  border: "none",
                  color: "#fff",
                  padding: "9px 26px",
                  fontSize: "12px",
                  fontWeight: "700",
                  cursor: "pointer",
                  fontFamily: "inherit",
                  letterSpacing: "0.5px",
                  textDecoration: "none",
                }}
              >
                GIVE
              </a>
            </div>
          ))}
        </div>

        {/* ── #10 The New Titus Family Home ── */}
        <div
          style={{
            marginTop: "3.5rem",
            display: "flex",
            gap: "2rem",
            flexWrap: "wrap",
            alignItems: "flex-start",
          }}
        >
          <div
            style={{
              flex: "0 0 320px",
              minWidth: "280px",
            }}
          >
            <p
              style={{
                textAlign: "center",
                fontSize: "12px",
                color: "#888",
                marginBottom: "0.6rem",
              }}
            >
              #10
            </p>

            <img
              src={tirtusfamily}
              alt="The Titus Family"
              style={{
                width: "100%",
                height: "190px",
                objectFit: "cover",
                borderRadius: "4px",
                marginBottom: "0.8rem",
              }}
            />

            <img
              src={tirtus}
              alt="The Titus Family"
              style={{
                width: "100%",
                height: "190px",
                objectFit: "cover",
                borderRadius: "4px",
                marginBottom: "0.8rem",
              }}
            />
          </div>

          <div
            style={{
              flex: 1,
              minWidth: "280px",
            }}
          >
            <h3
              style={{
                fontSize: "1.15rem",
                fontWeight: 700,
                color: "#222",
                margin: "0 0 0.8rem",
              }}
            >
              The New Titus Family Home
            </h3>

            <p
              style={{
                fontSize: "13.5px",
                lineHeight: "1.75",
                color: "#444",
                marginBottom: "0.85rem",
              }}
            >
              Help finish the New Titus Family Home and allow our family to
              move in and be safe.
            </p>

            <p
              style={{
                fontSize: "13.5px",
                lineHeight: "1.75",
                color: "#444",
                marginBottom: "0.85rem",
              }}
            >
              With all your donations, we were able to double your gift up to
              $20,000! We can now continue with the work on the inside of Titus
              Family Home.
            </p>

            <p
              style={{
                fontSize: "13.5px",
                lineHeight: "1.75",
                color: "#444",
                marginBottom: "0.85rem",
              }}
            >
              We met the matching challenge and now are closer to being able
              to complete the house.
            </p>

            <p
              style={{
                fontSize: "13.5px",
                lineHeight: "1.75",
                color: "#444",
                marginBottom: "0.85rem",
              }}
            >
              A special Thanks to the Pastor and church who made this matching
              challenge gift possible.
            </p>

            <p
              style={{
                fontSize: "13.5px",
                lineHeight: "1.75",
                color: "#444",
                marginBottom: "0.85rem",
              }}
            >
              We want to thank everyone who contributed to this success and to
              everyone who prayed for it. We are extremely grateful because
              without you, this would not be possible!
            </p>

            <p
              style={{
                fontSize: "13.5px",
                lineHeight: "1.75",
                color: "#444",
                marginBottom: "0.85rem",
              }}
            >
              Please pray as we still need the resources, about{" "}
              {cost("$22,000")} to finish the compound wall, street
              transformer, driveway and the dirt work.
            </p>

            <p
              style={{
                fontSize: "13.5px",
                lineHeight: "1.75",
                color: "#444",
                marginBottom: "1.2rem",
              }}
            >
              Thank you very much for your support.
              <br />
              Rev. Jameson P. Titus
            </p>

            {/* Titus Family General Donation */}
            <a
              href={titusFamilyDonateUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                background: "#e87b1e",
                border: "none",
                color: "#fff",
                padding: "9px 26px",
                fontSize: "12px",
                fontWeight: "700",
                cursor: "pointer",
                fontFamily: "inherit",
                letterSpacing: "0.5px",
                textDecoration: "none",
              }}
            >
              GIVE
            </a>
          </div>
        </div>

        {/* ── Footnote ── */}
        <p
          style={{
            textAlign: "center",
            fontSize: "12px",
            color: "#777",
            marginTop: "3rem",
          }}
        >
          When a specific need has been met, Christ For India reserves the
          right to distribute the funds where the need is greatest.
        </p>
      </div>

      {/* Responsive */}
      <style>{`
        @media (max-width: 720px) {
          .dev-projects-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
}

export default DevelopmentProjects;
